<template>
  <div>
    <div class="confirm-modal-block">
      <div class="confirm-modal-header-block">
        <p class="confirm-modal-header">
          {{ header }}
        </p>
        <p class="confirm-modal-subheader">
          {{ subheader }}
        </p>
      </div>

      <button class="confirm-modal-go-back-button" @click="handleRedirect">
        {{$resourceString['accounts.Virtualtray.Redirect.Label.Yes']}}
      </button>
      <button class="confirm-modal-continue-button" @click="hanldeNoRedirect">
      {{$resourceString['accounts.Virtualtray.Redirect.Label.No']}}
      </button>
    </div>
    <button
      class="confirm-modal-close-button wf-modal-button-close btn button-full"
      type="button"
      @click="closeFiltersModal"
    >
      <span
        class="
          confirm-modal-close-label
          png-icon
          png-icon-icons-symbols--k-txtclose
        "
        aria-label="Close modal"
      />
    </button>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["header", "subheader", "close"],

  methods: {
    ...mapActions({
      fetchTrayDetails: "myProject/fetchTrayDetails",
      setSelectedTray: "myTray/setSelectedTray"
    }),

    closeFiltersModal() {
      this.hideModal("redirect-confirm");
    },

    handleRedirect() {
      this.close();
    },

    hanldeNoRedirect() {
      this.setSelectedTray("");
      this.close();
    },

    hideModal(name) {
      this.$modal.hide(name + "-modal");
    }
  }
};
</script>

<style></style>
